import type { FC } from 'react'
import { classNames } from '@g4g/utils/src/react/class-names'
import RecipientConfirm from './RecipientConfirm'
import RecipientSelectProvider from './RecipientSelectProvider'
import RecipientRadioGroup from './RecipientRadioGroup'
import GiftSearchBar from '../gift/GiftSearchBar'
import LgBreakpoint from '@g4g/ui/src/utility/LgBreakpoint'
import RecipientDetail from './RecipientDetail'

const RecipientContentDesktop = () => (
  <div className="flex space-x-7">
    <div className="flex flex-col grow">
      <GiftSearchBar />
      <RecipientRadioGroup />
    </div>
    <div className="w-[400px] h-[400px] bg-gray-600/20 py-2 rounded">
      <RecipientConfirm />
      <RecipientDetail />
    </div>
  </div>
)

const RecipientContentMobile = () => (
  <div className="flex flex-col mt-4">
    <div className="sticky z-40 w-full top-16">
      <GiftSearchBar />
    </div>
    <RecipientRadioGroup />
    <RecipientConfirm />
  </div>
)

const RecipientContent: FC = () => (
  <RecipientSelectProvider>
    <div className="container">
      <h1
        className={classNames(
          'pt-0 mt-2 text-2xl font-bold text-white',
          'font-poppins sm:text-4xl lg:py-4'
        )}
      >
        Recipient
      </h1>
      <LgBreakpoint max={<RecipientContentMobile />} min={<RecipientContentDesktop />} />
    </div>
  </RecipientSelectProvider>
)

export default RecipientContent
